module.exports = __webpack_public_path__ + "assets1779866876160/img/logo-block.b2a020b6.png";